import React, { useEffect } from 'react'
import styles from './RaiseBar.module.css'
import { Slider } from '../ui/slider'
import useRaise from '@/src/hooks/data/useRaise'
import RaisePresets from './RaisePresets'

export default function RaiseBar({ setRaiseAmount, tempTableId, raiseAmount }) {
    const { minRaiseAmount, maxRaiseAmount } = useRaise(tempTableId)

    useEffect(() => {
        setRaiseAmount(minRaiseAmount)
    }, [minRaiseAmount])

    return (
        <div className={styles.raiseBarContainer}>
            <RaisePresets tempTableId={tempTableId} raiseAmount={raiseAmount} setRaiseAmount={setRaiseAmount} />
            <div className={styles.divider} />
            <div className={styles.raiseBarSliderContainer}>
                <Slider
                    orientation="vertical"
                    min={minRaiseAmount}
                    max={maxRaiseAmount}
                    value={[raiseAmount]}
                    step={1}
                    defaultValue={[minRaiseAmount]}
                    className={styles.raiseBarSlider}
                    onValueChange={(value) => setRaiseAmount(value[0])}
                />
            </div>
        </div>
    )
}